import { EditorView } from '@codemirror/view';
import { HighlightStyle, syntaxHighlighting } from '@codemirror/language';
import { tags as t } from '@lezer/highlight';

const customHighlightStyle = HighlightStyle.define([
  { tag: t.keyword, color: '#cb94f8' },
  { tag: [t.propertyName], color: '#cb94f8' },
  { tag: [t.string], color: '#9feefd' },
]);

const codeTheme = EditorView.theme(
  {
    '&': {
      backgroundColor: 'rgb(26, 26, 26)',
    },
    '.cm-content': {
      caretColor: 'red',
    },
    '.cb': {
      color: '#9E46F6',
    },
    '&.cm-focused .cm-cursor': {
      borderLeftColor: 'white',
    },
    '.cm-gutters': {
      backgroundColor: '#2a2c31',
      color: '#aaa',
      border: 'none',
    },
    '.cm-activeLine': {
      backgroundColor: '#2a2c31',
    },
    '.cm-tooltip': {
      backgroundColor: '#222227',
    },
    '.cm-tooltip-autocomplete': {
      '& > ul > li[aria-selected]': {
        backgroundColor: '#2a2c31',
        color: '#cb94f8',
      },
      border: '0.5px solid #333333',
    },
    '.cm-foldPlaceholder': {
      backgroundColor: '#2a2c31',
      border: 'none',
    },
  },
  { dark: true },
);

export const customCodeTheme = [
  codeTheme,
  syntaxHighlighting(customHighlightStyle),
];
